import { useOpMutation } from '../useOpMutation';

export const useCreateMfaCredential = () =>
  useOpMutation({
    apiEndpointName: 'createMfaCredential',
    queryKeysToInvalidate: [['listMfaCredentials']],
  });
